import { Blob } from "./Blob.js";
export const isBlob = (value) => value instanceof Blob;
